import { useMsal } from "@azure/msal-react";
import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { authAPI, searchAPI } from "services/apis.service";
import { useDispatch } from "react-redux";
import { setsearch, setsidebarDataCopy } from "context/features/dataSlice";
import { loginUser, logoutUser, setMicrosoftUser } from "context/features/authSlice";
import { toast } from "react-toastify";
import CustomLoader from "components/base/loader";
import { useAuth, consumeOAuthSignupContext } from "hooks/use-auth.hook";
import { Box } from "@mui/material";

export default function OauthLogin() {
  const { instance, inProgress } = useMsal();
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const handledRef = useRef(false);

  const { handleExternalLogin, logAuthError } = useAuth({
    handleLoading: () => {},
    toast,
  });

  const setSidebar = async (data) => {
    try {
      const sidebar = await axios.post(
        searchAPI.sidebar,
        {
          callingUserId: data.userId,
          userId: data.userId,
          includeDeletedRecords: 0,
        },
        {
          headers: {
            Authorization: `Bearer ${data.token}`,
          },
        }
      );

      dispatch(setsidebarDataCopy(sidebar.data));
    } catch (e) {
      console.error(e);
    }
  };

  const handleCleverLogin = async (provider) => {
    const urlParams = new URLSearchParams(location.search);
    const code = urlParams.get("code");

    if (code) {
      dispatch(logoutUser());
      localStorage.removeItem("user");
      dispatch(setsearch(""));
      try {
        const res = await axios.post(`${authAPI.cleverLogin}`, {
          code,
          provider,
          ...consumeOAuthSignupContext(),
        });
        localStorage.setItem("user", JSON.stringify(res.data));
        localStorage.setItem("login", true);
        setSidebar(res.data);

        dispatch(loginUser({ user: res.data }));
        localStorage.setItem("email", res.data.email);
        localStorage.setItem("clever", code);
        navigate("/");
      } catch (error) {
        console.error("Error sending the code to backend:", error);
        logAuthError(error, provider, "Redirect/OAuth");
        toast.error("There was an issue logging in with Clever.");
        navigate("/");
      }
    } else {
      logAuthError(
        `Clever redirect missing code. Query: ${location.search || "(empty)"}`,
        provider,
        "Redirect/OAuth",
        "Warning"
      );
      toast.error("Cannot login in at clever.");
      navigate("/");
    }
  };

  useEffect(() => {
    if (location.pathname.includes("/signin/clever") && !handledRef.current) {
      handledRef.current = true;
      handleCleverLogin("clever");
    } else if (location.pathname.includes("/signin/microsoft") && !handledRef.current && inProgress === "none") {
      handledRef.current = true;
      const handleMicrosoftRedirect = async () => {
        try {
          const response = await instance.handleRedirectPromise();
          if (response) {
            dispatch(setMicrosoftUser(true));
            const account = response.account;
            const request = {
              scopes: ["user.read"],
              account: account,
            };
            const accessTokenResponse = await instance.acquireTokenSilent(request);
            await handleExternalLogin(
              accessTokenResponse.accessToken,
              "Microsoft",
              authAPI.microsoftLogin
            );
            navigate("/");
          } else {
            handledRef.current = false;
          }
        } catch (error) {
          handledRef.current = false;
          console.error("Microsoft login error:", error);
          if (error.errorCode === "access_denied") {
            toast.error("Access denied. Please try again.");
          } else {
            toast.error("There was an issue logging in with Microsoft.");
          }
          navigate("/signin");
        }
      };
      handleMicrosoftRedirect();
    }
  }, [location.pathname, inProgress]);

  return (
    <Box className="circular-loader-center">
      <CustomLoader />
    </Box>
  );
};